import { createSelector } from 'reselect'

export const alertsSelector = (state) => state.alerts

export const alertTypesSelector = createSelector(
  alertsSelector,
  (alerts) => alerts.types
)
export const newAlertsCountSelector = createSelector(
  alertsSelector,
  (alerts) => alerts.newAlertsCount
)

export const alertsPriorityCount$ = createSelector(
  alertsSelector,
  (alerts) => alerts.alertsPriorityCount
)

export const isAlertRedirectedFromDashboard$ = createSelector(
  alertsSelector,
  (alerts) => alerts.isAlertRedirectedFromDashboard
)

export const alertsPredefinedFilters$ = createSelector(
  alertsSelector,
  (alerts) => alerts.predefinedFilters
)

export const patientAlertList$ = createSelector(
  alertsSelector,
  (alerts) => alerts.patientAlertList
)

export const alertPatientUuid$ = createSelector(
  alertsSelector,
  ({ alertPatientUuid }) => alertPatientUuid
)

export const alertsDashboardList$ = createSelector(
  alertsSelector,
  ({ dashboardData = [] }) => dashboardData
)

export const alertsDashboardListByCM$ = createSelector(
  alertsSelector,
  ({ dashboardAlertsByCaseManagers = [] }) => dashboardAlertsByCaseManagers
)

export const alertsDashboardListByFacility$ = createSelector(
  alertsSelector,
  ({ dashboardAlertsByFacilities = [] }) => dashboardAlertsByFacilities
)
